import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from "../shared/user.service";
import { AngularFireAuth } from "angularfire2/auth";
import { ObjectObservable } from "../../shared/base/object-observable";
import { User } from "../shared/user";
import { AuthService } from "../../core/auth.service";
import { NavService } from "../../core/nav.service";

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit, OnDestroy {
  userObservable: ObjectObservable<User>;
  private uid: String;

  constructor(private userService: UserService,
              private afAuth: AngularFireAuth) { }

  ngOnInit() {
    this.afAuth.authState.subscribe(auth => {
      if(auth) {
        this.uid = auth.uid;
        this.userObservable = this.userService.readChild(auth.uid);
      }
    });
  }

  ngOnDestroy() {
    this.userObservable = null;

  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/user-profile/user-profile.component.ts